import React, { useState } from 'react';
import { motion } from 'framer-motion';
import type { Article } from '../../types/blog';
import ArticleCard from './ArticleCard';
import Pagination from '../ui/Pagination';

interface ArticleListProps {
  articles: Article[];
  perPage?: number;
}

const ArticleList: React.FC<ArticleListProps> = ({ articles, perPage = 9 }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(articles.length / perPage));
  const start = (currentPage - 1) * perPage;
  const pageArticles = articles.slice(start, start + perPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (articles.length === 0) {
    return (
      <div className="text-center py-20 text-fg-muted">
        <p className="text-lg">Aucun article dans cette catégorie pour le moment.</p>
      </div>
    );
  }

  return (
    <div>
      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        initial="hidden"
        animate="show"
        variants={{
          hidden: {},
          show: { transition: { staggerChildren: 0.07 } },
        }}
      >
        {pageArticles.map((article) => (
          <motion.div
            key={article.slug}
            variants={{
              hidden: { opacity: 0, y: 24 },
              show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } },
            }}
          >
            <ArticleCard article={article} />
          </motion.div>
        ))}
      </motion.div>

      {totalPages > 1 && (
        <div className="mt-10">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default ArticleList;
